const ROUTE_SEPARATOR = '/';

export const normalizePathname = (routePattern: string, pathname: string) => {
  const patternLength = routePattern.split(ROUTE_SEPARATOR).length;
  const pathParts = pathname.split(ROUTE_SEPARATOR);

  return pathParts.slice(0, patternLength).join(ROUTE_SEPARATOR);
};
